// extracted by mini-css-extract-plugin
export default {"populationBasedFundingViewComponent":"PopulationBasedFundingView_populationBasedFundingViewComponent__B5VFa"};